import { useMemo } from 'react'
import { useFirestoreArrayContainsOrderBy } from '../firebase/useFirestore'
import useSharedCollection from '../firebase/useSharedCollection'
import resolveResearchIdsForEffect from '../helpers/dashboardHelpers/resolveResearchIdsForEffect'

// Resolves the targetgroups that have research data for an effect, and
// builds a lookup of ResearchIDs per targetgroup so a dashboard card can
// filter responses by ResearchID when the user picks a targetgroup.
//
// Stakeholders + Research are shared via useSharedCollection so N effect cards
// on the same dashboard do not open N duplicate listeners.
//
// See docs/decisions.md ADR-016 for why Research is the (questionnaire × targetgroup) bridge.
const useEffectTargetgroups = (effect) => {
    const stakeholders = useSharedCollection('Stakeholders')
    const researches = useSharedCollection('Research')
    const questionnaireFields = useFirestoreArrayContainsOrderBy(
        'QuestionnaireFields',
        'EffectId',
        effect?.ID || '',
        'IndicatorPosition',
        'asc'
    )

    return useMemo(() => {
        if (!effect?.ID) {
            return {
                targetgroups: [],
                researchIdsByTargetgroup: {},
                questionnaireIds: [],
                multipleQuestionnaires: false,
                loading: true,
            }
        }

        const loading =
            !Array.isArray(stakeholders) ||
            !Array.isArray(researches) ||
            !Array.isArray(questionnaireFields)

        if (loading) {
            return {
                targetgroups: [],
                researchIdsByTargetgroup: {},
                questionnaireIds: [],
                multipleQuestionnaires: false,
                loading: true,
            }
        }

        const resolved = resolveResearchIdsForEffect({
            effect,
            stakeholders,
            questionnaireFields,
            researches,
        })

        return { ...resolved, loading: false }
    }, [effect, stakeholders, researches, questionnaireFields])
}

export default useEffectTargetgroups
